import { useEffect, useState } from "react";
import { SiteListApiItem } from "../../site-listings/services/siteListingConfig";
import { fetchSEOConfigs } from "../services/seoConfig";
import { computeSEOAnalysis } from "./useSEOAnalysis";
import { toForm } from "../types";

export interface SiteSeoStats {
  pageCount: number;
  score: number;
}

export const useSiteSeoStats = (sites: SiteListApiItem[]) => {
  const [stats, setStats] = useState<Record<number, SiteSeoStats>>({});

  useEffect(() => {
    if (!sites.length) return;
    let cancelled = false;

    Promise.all(
      sites.map((site) =>
        fetchSEOConfigs(site.id)
          .then((response) => ({
            siteId: site.id,
            results: response.data.results || [],
          }))
          .catch(() => ({ siteId: site.id, results: [] })),
      ),
    ).then((allResults) => {
      if (cancelled) return;
      const next: Record<number, SiteSeoStats> = {};
      allResults.forEach(({ siteId, results }) => {
        const scores = results.map(
          (config) => computeSEOAnalysis(toForm(config)).score,
        );
        const average =
          scores.length > 0
            ? Math.round(
                scores.reduce((sum, score) => sum + score, 0) / scores.length,
              )
            : 0;
        next[siteId] = { pageCount: results.length, score: average };
      });
      setStats(next);
    });

    return () => {
      cancelled = true;
    };
  }, [sites]);

  return stats;
};
